import { FC } from 'react';
import s from './company-sensitive-modal.module.css';
import { Loader } from '../../../../../../../components/loader/loader';
import { ModalProps, Modal } from '../../../../../../../components/modal/modal';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useCompanyStore } from '../../../../../../../store/use-company-store';

export const CompanySensitiveModal: FC<ModalProps> = (props) => {
  const { t } = useLang();

  const email = '';
  const { companyProfile, company, isLoading } = useCompanyStore();
  const { address, city, country } = companyProfile?.legal_address || {};
  const { bik, bin, inn, kpp } = companyProfile?.credentials || {};

  return (
    <Modal {...props}>
      {isLoading && <Loader />}
      <ul className={s.feature}>
        <li className={s.pair}>
          <span className={s.name}>{t('Полное название')}:</span>
          <span className={s.value}>{company?.company_name}</span>
        </li>
        <li className={s.pair}>
          <span className={s.name}>{t('E-mail')}:</span>
          <span className={s.value}>{email}</span>
        </li>
        <li className={s.pair}>
          <span className={s.name}>{t('Юридический адрес')}:</span>
          <span className={s.value}>
            {[country, city, address].filter((item) => !!item).join(', ')}
          </span>
        </li>
        <li className={s.pair}>
          <span className={s.name}>{t('БИК')}:</span>
          <span className={s.value}>{bik}</span>
        </li>
        <li className={s.pair}>
          <span className={s.name}>{t('БИН')}:</span>
          <span className={s.value}>{bin}</span>
        </li>
        <li className={s.pair}>
          <span className={s.name}>{t('ИНН')}:</span>
          <span className={s.value}>{inn}</span>
        </li>
        <li className={s.pair}>
          <span className={s.name}>{t('КПП')}:</span>
          <span className={s.value}>{kpp}</span>
        </li>
      </ul>
    </Modal>
  );
};
